// Import all JavaScript & CSS files from src/_components
import components from "bridgetownComponents/**/*.{js,jsx,js.rb,css}"

import "./life-in-weeks.js"

console.info("Bridgetown is loaded!")
